export interface Breadcrumb {
  label: string;
  url: string;
}

export enum BreadcrumbEnum {
  HOME = 'routeBreadcrumbHome',
  MMB = 'routeBreadcrumbMmb',
  TRIPS = 'routeBreadcrumbTrips',  
}